<template>
    <div class="loader"></div>
</template>

<script setup lang="ts"></script>

<style scoped>
.loader {
    width: 7rem;
    scale: 1.25;
    aspect-ratio: 1;
    border-radius: 50%;
    background:
        radial-gradient(farthest-side, #b591fc 94%, #0000) top / 0.5rem 0.5rem
            no-repeat,
        conic-gradient(#0000 30%, #b591fc);
    -webkit-mask: radial-gradient(
        farthest-side,
        #0000 calc(100% - 0.5rem),
        #000 0
    );
    animation: l13 0.75s infinite linear;
}
@keyframes l13 {
    100% {
        transform: rotate(1turn);
    }
}
</style>
